import { render, staticRenderFns } from "./SharedProduct.vue?vue&type=template&id=2641d850&scoped=true"
import script from "./SharedProduct.vue?vue&type=script&lang=js"
export * from "./SharedProduct.vue?vue&type=script&lang=js"
import style0 from "./SharedProduct.vue?vue&type=style&index=0&id=2641d850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641d850",
  null
  
)

export default component.exports